import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import ItemsEdit from '../ItemsScreen/containers/ItemsEdit/ItemsEdit';
import itemsStore from '../ItemsScreen/store/itemsStore';
import { defaultItem } from '../ItemsScreen/constants/items';
import { itemManagementNavigation } from './constants/itemManagement';
import ItemBranchesConfiguration from './containers/ItemBranchesConfiguration/ItemBranchesConfiguration';
import ItemBranchesModifiers from './containers/ItemBranchesModifiers/ItemBranchesModifiers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { getTranslate } from '~/utils/helpers';
import ScreenTabsNavigation from '~/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import Headers from '~/view/containers/Headers/Headers';
import { SCREENS } from '~/constants/screens';
import { Table } from '~/view/components/Table/Table';
import { isObjectsEqual } from '~/helpers';

@observer
class ItemManagementScreen extends React.Component<any, {}> {
  render() {
    const { match } = this.props;
    const itemId = match.params.id ? Number(match.params.id) : 0;
    const modifierId = Number(itemsStore.item?.modifiers?.[0]?.id ?? 0);
    const isHeaderLoading = itemId !== 0 && isObjectsEqual(itemsStore.item, defaultItem, ['name']) ? true : false;

    return (
      <Table>
        <Headers>
          <HeaderBack
            title={itemsStore.item ? getTranslate(itemsStore.item.name) : ''}
            isLoading={isHeaderLoading}
            noTranslation
            path={SCREENS.ITEMS()}
          />
        </Headers>

        <ScreenTabsNavigation className="mt-6" options={itemManagementNavigation(itemId, modifierId)} />

        <Switch>
          {/* Create Or Edit Item (Main Details) */}
          <Route exact path={[SCREENS.ITEMS_CREATE(), SCREENS.ITEMS_EDIT(':id')]} component={ItemsEdit} />
          {/* Item Branches Configuration */}
          <Route path={SCREENS.ITEMS_BRANCHES_CONFIGURATION(':id')} component={ItemBranchesConfiguration} />
          {/* Item Branches Modifiers */}
          <Route exact path={SCREENS.ITEMS_BRANCHES_MODIFIERS(':id')} component={ItemBranchesModifiers} />
        </Switch>
      </Table>
    );
  }
}

export default withRouter(ItemManagementScreen);
